<template>
  <div class="card p-shadow-app">
    <ConfirmDialog />
    <Message
      :severity="messageSeverity"
      :closable="false"
      :icon="messageIcon"
      v-if="messageDetail && messageSeverity"
    >
      <span class="p-d-flex p-ai-center p-jc-between">
        {{ messageDetail }}
      </span>
    </Message>
    <Button
      label="Autenticar com Google"
      icon="pi pi-google"
      @click="openGoogleAuth"
      v-if="hasToken == false"
    />
  </div>
</template>

<script>
import googleContactsService from "@/services/googleContacts.service";
export default {
  data() {
    return {
      loading: false,
      hasToken: false,
      authUrl: null,
      contacts: [],
      messageSeverity: null,
      messageDetail: null,
      messageIcon: "pi-exclamation-triangle",
    };
  },
  computed: {
    code() {
      return this.$route.query.code || null;
    },
    state() {
      return this.$route.query.state || null;
    },
    error() {
      return this.$route.query.error || null;
    },
  },
  async created() {
    if (this.error) {
      this.messageIcon = "pi-exclamation-triangle";
      this.messageSeverity = "error";
      this.messageDetail = this.error;
      return;
    } else if (!this.code && !this.state) {
      this.hasToken = await googleContactsService.userHasToken();
      if (!this.hasToken) {
        this.messageIcon = "pi-info-circle";
        this.messageSeverity = "info";
        this.messageDetail =
          "É necessário autenticar-se com a sua conta google para continuar.";
        return;
      }
    } else if (this.code && this.state) {
      this.messageIcon = "pi-check-circle";
      this.messageSeverity = "success";
      this.messageDetail = "Autenticado com sucesso!";
      return this.updateData();
    }
    this.messageIcon = "pi-check-circle";
    this.messageSeverity = "success";
    this.messageDetail = "Tudo Pronto para receber os contactos dos clientes!";
  },
  methods: {
    openGoogleAuth() {
      let title = `Autenticação Google`;
      let message = `Irá ser redirecionado para a página de autenticação. `;
      message += `Pretende continuar?`;
      this.$confirm.require({
        header: title,
        message: message,
        icon: "pi pi-question-circle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: async () => {
          this.loading = true;
          this.authUrl = await googleContactsService.oauthUrl();
          if (this.authUrl) {
            return (window.location = this.authUrl);
          }
        },
        reject: () => {
          this.messageIcon = "pi-info-circle";
          this.messageSeverity = "warn";
          this.messageDetail = "É necessário autenticar-se para continuar!";
        },
      });
    },
    updateData() {
      this.loading = true;
      let bodyParams = {
        code: this.code,
        state: this.state,
      };
      googleContactsService.setToken(bodyParams).then((response) => {
        if (!response) {
          this.messageSeverity = "error";
          this.messageDetail = "Erro ao autenticar.";
        }
        window.location = "/googleContacts";
      });
    },
  },
};
</script>
